var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M22,8.581a1,1,0,0,1-1-1V5.054A4.3,4.3,0,0,0,16.5,1H5.5A4.3,4.3,0,0,0,1,5.054V7.581a1,1,0,0,1-1,1,1,1,0,0,1-1-1V5.054A6.3,6.3,0,0,1,5.5-1h11A6.3,6.3,0,0,1,23,5.054V7.581A1,1,0,0,1,22,8.581Z",
    transform: "translate(0 17.419)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M5.054-1A6.054,6.054,0,1,1-1,5.054,6.061,6.061,0,0,1,5.054-1Zm0,10.108A4.054,4.054,0,1,0,1,5.054,4.059,4.059,0,0,0,5.054,9.108Z",
    transform: "translate(5.946 0)",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconWhite);
export default __webpack_public_path__ + "static/media/info-icon-white.743031b582f0c951c85f11ae103a85d8.svg";
export { ForwardRef as ReactComponent };